import { Button, Collapse, makeStyles, TableCell, TableRow, Tooltip, Typography } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import React, { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
    title?: string;
    stringData?: string;
    visible?: boolean;
    tooltip?: string;
}

function TableRowCollapse(props: Props) {

    const classes = useRowStyles();

    const [open, setOpen] = React.useState<boolean>(false);

    const defaultProps: Props = {
        title: 'Detalhes',
        tooltip: 'Não há detalhes a serem exibidos',
        visible: true,
        ...props,
    };

    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                {props.children}
                {defaultProps.visible &&
                    <TableCell>
                        <Tooltip arrow title={!defaultProps.stringData && defaultProps.tooltip ? defaultProps.tooltip : ''}>
                            <span>
                                <Button
                                    color="default"
                                    variant="contained"
                                    size="small"
                                    disabled={!defaultProps.stringData}
                                    startIcon={open ? <VisibilityOff /> : <Visibility />}
                                    onClick={() => setOpen(!open)}>
                                    Ver
                                </Button>
                            </span>
                        </Tooltip>
                    </TableCell>
                }
            </TableRow>
            {defaultProps.visible &&
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Typography style={{ fontWeight: 'bold' }} variant="body1" component="div">
                                {defaultProps.title}
                            </Typography>
                            <ul style={{ marginTop: 2 }}>
                                {defaultProps.stringData && defaultProps.stringData.replace(/\\n/g, '\n').split('\n').map((line, index) => {
                                    if (line) { return (<li key={index}>{line}</li>); } else { return null; }
                                })}
                            </ul>
                        </Collapse>
                    </TableCell>
                </TableRow>
            }
        </React.Fragment>
    );
}

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
});

export default TableRowCollapse;